import { render, staticRenderFns } from "./CartProductTotalPrice.vue?vue&type=template&id=72402f50&scoped=true&"
import script from "./CartProductTotalPrice.vue?vue&type=script&lang=js&"
export * from "./CartProductTotalPrice.vue?vue&type=script&lang=js&"
import style0 from "./CartProductTotalPrice.vue?vue&type=style&index=0&id=72402f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72402f50",
  null
  
)

export default component.exports